import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import "./InfoModal.css";

/**  Props:
 *    modalShow : Boolean
 *
 *    onHide : Function
 *
 *    showHeading : Boolean ( default : true)
 *      heading : String
 *
 *    showBody : Boolean (default : true)
 *      bodyHTML : Boolean (default : false)
 *      bodyHTMLFunction : React.Component (default : undefined)
 *      bodyHeading : String
 *      bodyContent : String
 *
 *    showFooter : Boolean (default : true)
 *      actionButtonVariant : String (bootstrap colors primary, secondary Etc)
 *      actionButton : Function
 *      actionButtonText : String
 *      closeButton : Boolean
 */
export class InfoModal extends Component {
  render() {
    return (
      <Modal
        show={this.props.modalShow}
        onHide={() => this.props.onHide()}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="infomodal-modal"
      >
        {this.props.showHeading && (
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter" className="infomodal-heading">
              {this.props.heading}
            </Modal.Title>
          </Modal.Header>
        )}

        {this.props.showBody && (
          <Modal.Body>
            {!this.props.bodyHTML ? (
              <>
                <h4>{this.props.bodyHeading}</h4>
                <p>{this.props.bodyContent}</p>
              </>
            ) : (
              this.props.bodyHTMLFunction()
            )}
          </Modal.Body>
        )}
        {this.props.showFooter && (
          <Modal.Footer>
            <Button
              variant={
                this.props.actionButtonVariant
                  ? this.props.actionButtonVariant
                  : "primary"
              }
              onClick={this.props.actionButton}
            >
              {this.props.actionButtonText}
            </Button>
            {this.props.closeButton ? (
              <Button variant="secondary" onClick={() => this.props.onHide()}>
                Close
              </Button>
            ) : null}
          </Modal.Footer>
        )}
      </Modal>
    );
  }
}

InfoModal.defaultProps = {
  showHeading: true,
  showBody: true,
  showFooter: true,
  bodyHTML: false,
  bodyHTMLFunction: () => {},
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InfoModal);
